import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

type BarChartOneProps = {
  series: { name: string; data: number[]; }[];
};

const BarChartOne: React.FC<BarChartOneProps> = ({ series }) => {
  const options: ApexOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
      parentHeightOffset: 0,
      height: '100%'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"]
    },
    xaxis: {
      categories: [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
      ]
    },
    yaxis: {
      title: {
        text: "Reservas"
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (value: number) {
          return value === 1 ? "1 reserva" : `${value} reservas`;
        }
      }
    }
  };

  return (
    <div className="h-full w-full">
      <Chart 
        options={options} 
        series={series} 
        type="bar" 
        height="100%" 
        width="100%"
      />
    </div>
  );
};

export default BarChartOne;
